/// <reference path="PopupEmailPreview.js" />

class NewsletterDesign extends PopupEmailPreview {
	constructor(el, options) {
		super(el, options);
		this.subjectBox = document.getElementById(options.subjectBox);
		this.salutationBox = document.getElementById(options.salutationBox);
		this.messageBox = document.getElementById(options.messageBox);
	}

	getParameters() {
		return {
			"PLH_subject": this.subjectBox.value,
			"PLH_salutation": this.salutationBox.value,
			"PLH_message": this.messageBox.value
		};
	}
}
